import script from "./EditableComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableComponent.vue?vue&type=script&lang=ts&setup=true"

import "./EditableComponent.vue?vue&type=style&index=0&id=61f277b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61f277b0"]])

export default __exports__